import * as h2Api from '../../h2Api'
import * as profileActions from '../../actions/colleges'
import { POPUP_JOURNAL_COMPLETION } from '../../actions/journals'
import { handleReducingJournalForItem } from '../../actions'

const initialState = {
  selected: null
}
const collegeProfile = (state = initialState, action) => {
  switch (action.type) {
    case profileActions.CLEAR_SELECTED:
      return initialState

    case profileActions.RATE_COLLEGE:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        const p = action.restCall.result
        const { rating, ...itms } = state.selected.personalization

        return {
          ...state,
          selected: {
            ...state.selected,
            personalization: {
              ...itms,
              ...p
            }
          }
        }
      }

      return state

    case POPUP_JOURNAL_COMPLETION:
      return handleReducingJournalForItem(action, state, 'selected')

    case profileActions.COLLEGE_LOADED:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        const p = action.restCall.result

        return {
          ...state,
          selected: p
        }
      }

      return state

    default:
      return state
  }
}

export default collegeProfile
